export const parsePaymentRetrySession = (detailPageJson, uuid) => {
    if (!detailPageJson || !uuid) return null

    try {
        const detailPage = JSON.parse(detailPageJson)
        return detailPage?.token ? detailPage : null
    } catch {
        return null
    }
}
